import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import './styles/index.css'
import './styles/admin.css'
import './styles/portal.css'
import './styles/auth.css'
import './styles/landing.css'
import './styles/icons.css'
import './styles/upgrade-pricing.css'
import { setupEnglishFormValidation } from './utils/formValidation.js'
import { setupAxiosSessionTimeoutInterceptor } from './utils/sessionTimeout.js'
import './styles/static-wechat-pay.css'

setupEnglishFormValidation()
setupAxiosSessionTimeoutInterceptor()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)
